import React, { FC, useState } from 'react'
import { Button } from 'react-bootstrap'
import GoogleLogin, { GoogleLoginResponseOffline, GoogleLoginResponse } from 'react-google-login'
import { inject, observer } from 'mobx-react'
import API from '@aws-amplify/api'

import config from '../../config'

const LinkEmail: FC = () => {
  const [isOffice, setIsOffice] = useState(false)

  function instanceOfOfflineResponse(
    object: GoogleLoginResponse | GoogleLoginResponseOffline,
  ): object is GoogleLoginResponseOffline {
    return 'code' in object
  }

  const handleGoogleResponse = async (
    response: GoogleLoginResponseOffline | GoogleLoginResponse,
  ): Promise<void> => {
    if (instanceOfOfflineResponse(response)) {
      const payload = {
        code: response.code,
      }

      const myInit = { body: payload }

      try {
        await API.post('mav-outlook-api', '/users/grant/google', myInit)

        // console.log(response)
      } catch (e) {
        console.error(e)
      }
    }
  }
  const handleOutlookResponse = (): void => {
    window.location.assign(
      `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?response_type=code&client_id=6741dd84-641f-4a4b-996e-ec4464e135c3&redirect_uri=${config.APP_BASE_URL}%2Fauthorize&scope=openid%20profile%20User.Read%20Mail.Send%20offline_access%20Mail.Read`,
    )
  }

  return (
    <div className="email-linked block container">
      <h4>Before taking-off, you will need to authenticate with your email account</h4>
      {isOffice ? (
        <Button
          className="connect-to-outlook"
          variant="primary"
          block
          onClick={handleOutlookResponse}
        >
          Connect to Outlook
        </Button>
      ) : (
        <GoogleLogin
          clientId="650904338442-rksot2v9d7pg2oise65n7hkjbv5o0dnk.apps.googleusercontent.com"
          buttonText="Sign in with Google"
          scope="https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/gmail.readonly"
          accessType="offline"
          responseType="code"
          onSuccess={handleGoogleResponse}
          onFailure={handleGoogleResponse}
          disabled={false}
          cookiePolicy="single_host_origin"
          style={{ fontFamily: 'Roboto' }}
        />
      )}
      <div className="bottom-section">
        <span>{isOffice ? 'Not using Outlook?' : 'Not using Gmail?'}</span>
        <Button
          className="swtich-button"
          onClick={(): void => {
            setIsOffice(!isOffice)
          }}
          variant="link"
        >
          {isOffice ? 'switch to Google' : 'switch to Outlook'}
        </Button>
      </div>
    </div>
  )
}

export default inject('prospects', 'settings')(observer(LinkEmail))
